import "./SimpleSiteSearchStyles.scss";
import axios from "axios";
import $ from "jquery";
import { dnbComLog, isNotUndefined, LogSeverity } from "../FunctionsCore";
const getKeys = (object, path) => {
    let titleList = "";
    for (const key in object) {
        if (window.Object.prototype.hasOwnProperty.call(object, key)) {
            const objectKeyValue = object[key];
            if (key !== "jcr:primaryType" && window.String(objectKeyValue.title).toLowerCase().includes(path)) {
                let imgTag = "";
                if (isNotUndefined(objectKeyValue.img)) {
                    imgTag = `<img src="${objectKeyValue.img}" style="width: 90px; height: 90px;">`;
                }
                titleList += `<li><a href="${objectKeyValue.url}.html">${imgTag}${objectKeyValue.title}</a></li>`;
            }
        }
    }
    return titleList;
};
const simpleSiteSearch = (simpleSiteSearchParameter) => {
    $(() => {
        if (simpleSiteSearchParameter.scroll_to_results === "true") {
            $("html, body").animate({
                "scrollTop": $(".search-form").offset().top,
            }, 500);
        }
        const $suggesstionBox = $("#suggesstion-box");
        const $searchBox = $("#search-box");
        // Clear search entry field on 'X' click
        $(".search-clear").on("click", () => {
            $searchBox.val("");
            $suggesstionBox.hide();
        });
        // Quick links population of value pairs
        let finalList;
        if (simpleSiteSearchParameter.quickLinksFunctionality === "true") {
            // TODO Does this work? Setting a variable inside a network request callback?
            axios
                .get(simpleSiteSearchParameter.quickLinksPath)
                .then((ax) => {
                finalList = ax.data;
            });
        }
        // Search entry field keystroke event
        $searchBox.on("keyup", function () {
            const $this = $(this);
            const thisValue = $this.val();
            if (typeof thisValue !== "string") {
                throw new Error();
            }
            if (thisValue.length > 2) {
                let quickLinks = "";
                let displayText = "";
                if (simpleSiteSearchParameter.quickLinksFunctionality === "true") {
                    // Populate links based on type-ahead
                    displayText = getKeys(finalList, thisValue.toLowerCase());
                    // Trigger initial modal display content
                    if (displayText.length > 3) {
                        quickLinks += `<div class="search-quicklinks-title">${simpleSiteSearchParameter.quickLinksTitle}</div>`;
                        quickLinks += `<ul class="search-quicklinks-list" list-style: none; id="suggest-list">${displayText}</ul>`;
                    }
                }
                $searchBox.css("background", "#ffffff no-repeat 165px");
                axios
                    .get(simpleSiteSearchParameter.autoSuggestPath, {
                    "params": `${simpleSiteSearchParameter.searchTermParamName}=${thisValue}`,
                })
                    .then((ax) => {
                    const autoSuggestData = simpleSiteSearchParameter.autoSuggetFunctionality === "true" ? `<div class="search-suggest-title">${simpleSiteSearchParameter.autoSuggestTitle}</div>${ax.data}` : "";
                    $suggesstionBox.show();
                    $suggesstionBox.html(quickLinks + autoSuggestData);
                    $searchBox.css("background", "#ffffff");
                })
                    .catch((er) => dnbComLog(LogSeverity.ERROR, "Network request failed", er));
            }
            else {
                $suggesstionBox.hide();
            }
        });
    });
};
export { simpleSiteSearch };
